import React from 'react';

import { AgtBestand5JahresVerlauf } from 'app/components/berichte/bestand/AgtBestand5JahresVerlauf';
import { AgtNeugeschaeft } from 'app/components/berichte/bestand/AgtNeugeschaeft';
import { BestandUndBewertungsliste } from 'app/components/berichte/bestand/BestandUndBewertungsliste';
import { DatenStand, DatenStandAkumaPrime } from 'app/components/berichte/DatenStand';
import { Geburstagsliste } from 'app/components/berichte/personal/Gerburtstagsliste';
import { Jubelliste } from 'app/components/berichte/personal/Jubelliste';
import { AgenturVblListe } from 'app/components/berichte/personal/AgenturVblListe';
import { FilterStearts as AllSteartsExcept, LeiterSpeziSteartIds, MultiSteartIds, SpeziSteartIds, Steart } from '../core/steart.model';
import { ITreeNodeModel } from '../core/tree.node.model';
import { AgenturenBetreungList } from 'app/components/berichte/orga/UnbetreuteAgenturenList';
import { DigitalreportListe } from 'app/components/berichte/digitalreport/DigitalreportListe';
import { AgtErrungenschaftenOverview } from 'app/components/berichte/errungenschaften/AgtErrungenschaftenOverview';
import { AgtErrungenschaftenList } from 'app/components/berichte/errungenschaften/AgtErrungenschaftenList';
import { LeadNowListe } from 'app/components/berichte/leadnow/LeadNowListe';
import { LeadNowKwkList } from 'app/components/berichte/leadnow/LeadNowKwkList';
import { LeadNowGpConsecutiveListe } from 'app/components/berichte/leadnow/LeadNowGpConsecutiveListe';
import { LeadNowType } from 'app/stores/ui/agt.leadnow.ui.store';
import { FacebookListe } from 'app/components/berichte/socialmedia/FacebookListe';
import { InstagramListe } from 'app/components/berichte/socialmedia/InstagramListe';
import { TiktokListe } from 'app/components/berichte/socialmedia/TiktokListe';
import { KvmListe } from 'app/components/berichte/kvm/KvmListe';
import { StsListe } from 'app/components/berichte/sts/StsListe';
import { GoogleProfileListe } from 'app/components/berichte/googleprofile/GoogleProfileListe';
import { AgtGoogleProfileMultiGp26Liste } from 'app/components/berichte/googleprofile/GoogleProfileMultiGp26Liste';
import { FansFollowerListe } from 'app/components/berichte/socialmedia/FansFollowerListe';
import { LeadNowVerteilungGoogleMap } from 'app/components/berichte/leadnow/LeadNowVerteilungGoogleMap';
import { GeschaefstellenMap } from 'app/components/berichte/leadnow/GeschaeftsellenMap';
import { AmisNowListe } from 'app/components/berichte/amisnow/AmisNowListe';
import { WerkzeugkofferOverviewListe } from 'app/components/berichte/werkzeugkoffer/WerkzeugkofferOverviewListe';
import { WerkzeugkofferFzwListe } from 'app/components/berichte/werkzeugkoffer/WerkzeugkofferFzwListe';
import { WerkzeugkofferBakListe } from 'app/components/berichte/werkzeugkoffer/WerkzeugkofferBakListe';
import { BestandsnachfolgeplanungListe } from 'app/components/berichte/nachfolgeplanung/BestandsnachfolgeplanungListe';
import { AgtBestandsnachfolgeplanung } from 'app/components/berichte/nachfolgeplanung/AgtBestandsnachfolgeplanung';
import { LinkedInListe } from 'app/components/berichte/socialmedia/LinkedInListe';
import { SichtkontakteListe } from 'app/components/berichte/socialmedia/SichtkontakteListe';
import { AkumaMultiGpList } from 'app/components/berichte/multigp/2026/AkumaMultiGpList';
import { MultiGp2026 } from 'app/components/berichte/multigp/2026/MultiGp2026';
import { AnalyticsStoresList } from 'app/components/admin/imports/AnalyticsStoresList';
import { AnalyticsStoresByDimensionList } from 'app/components/admin/imports/AnalyticsStoresByDimensionList';
import { UsageOverview } from 'app/components/berichte/usage/UsageOverview';
import { UsageAnmeldequoteSteartYtd } from 'app/components/berichte/usage/UsageAnmeldequoteSteartYtd';
import { UsageAnmeldequoteVDYtd } from 'app/components/berichte/usage/UsageAnmeldequoteVDYtd';
import { UsageLoginAvgVdYtd } from 'app/components/berichte/usage/UsageLoginAvgVdYtd';
import { UsageViewVdYtd } from 'app/components/berichte/usage/UsageViewVdYtd';
import { LeadNowConversionListe } from 'app/components/berichte/leadnow/LeadNowConversionListe';
import { LeadNowConversionHistory } from 'app/components/berichte/leadnow/LeadNowConversionHistory';
import Config from 'Config';

export const BerichteTreeNodes: ITreeNodeModel = {
	name: 'root',
	icon: 'root',
	path: '',
	nodes: [
		{
			name: 'Produktion',
			icon: 'chart-line',
			path: 'production',
			visibileForRoles: AllSteartsExcept([Steart.DVSADMIN]),
			nodes: [
				{
					name: 'GSW',
					icon: '',
					path: 'gsw',
					visibileForRoles: [Steart.GSL],

					nodes: [
						{
							name: 'TODO',
							icon: '',
							path: 'xx',
							component: <div> </div>,
							datenStand: <DatenStand dataType="aup_bestand" />,
							hideFilter: true,
						},
					],
				},
				{ name: 'Geschäftsplan', icon: '', path: 'gp' },
				{ name: 'Agentur GP Positionen', icon: '', path: 'agtpos' },
				{ name: 'Ring', icon: '', path: 'ring', visibileForRoles: [Steart.VBL, ...SpeziSteartIds, ...LeiterSpeziSteartIds] },
				{
					name: 'Herbstwerbung',
					icon: '',
					path: 'herbst',
					// visibileForRoles: [Steart.VBL, ...SpeziSteartIds, ...LeiterSpeziSteartIds]
				},
			],
		},
		{
			name: 'Bestand',
			icon: 'landmark',
			path: 'bestand',
			visibileForRoles: AllSteartsExcept([Steart.DVSADMIN]),

			nodes: [
				{
					name: 'AdZ',
					icon: '',
					path: 'adz',
					nodes: [
						{
							name: 'Fitness-Tracker',
							icon: '',
							path: 'fit',
						},
						{
							name: 'AdZ Empfehlungen',
							icon: '',
							path: 'empf',
						},
					],
				},
				{
					name: 'Bestand und Bewertung',
					icon: '',
					path: 'bestandundbewertung',
					component: <BestandUndBewertungsliste />,
					datenStand: <DatenStand dataType="aup_bestand" />,
					visibileForRoles: [Steart.VBL, ...SpeziSteartIds, ...LeiterSpeziSteartIds],
				},
				{
					name: 'Bestandsnachfolge',
					icon: '',
					path: 'bestandsnachfolge',
					visibileForRoles: [Steart.VBL, ...SpeziSteartIds, ...LeiterSpeziSteartIds, Steart.LDP],
					nodes: [
						{
							name: 'Nachfolgeplanung',
							icon: '',
							path: 'nachfolgeplanung',
							component: <BestandsnachfolgeplanungListe />,
							agtComponent: <AgtBestandsnachfolgeplanung />,
							datenStand: <DatenStand dataType="aup_bestand" />,
							lastPathIsParam: true,
							visibileForRoles: [Steart.VBL, ...SpeziSteartIds, ...LeiterSpeziSteartIds, Steart.LDP],
						},
						// {
						// 	name: 'Bestandsqualität (geplannt 2026)',
						// 	icon: '',
						// 	path: 'bstqualitaet',
						// 	visibileForRoles: [Steart.VBL, ...SpeziSteartIds, ...LeiterSpeziSteartIds],
						// 	nodes: []
						// }
					],
				},
				{
					name: 'Digital-Report',
					icon: '',
					path: 'digitalreport',
					component: <DigitalreportListe />,
					datenStand: <DatenStand dataType="digitalreport" />,
				},

				{
					name: 'Bestandsanalyse',
					icon: '',
					path: 'analyse',
					visibileForRoles: [Steart.VBL, ...SpeziSteartIds, ...LeiterSpeziSteartIds],

					nodes: [
						{
							name: 'Agenturbestand im 5-Jahresverlauf',
							icon: '',
							path: 'agtbestand5jahre',
							component: <AgtBestand5JahresVerlauf />,
							datenStand: <DatenStand dataType="aup_bestand" />,
							hideFilter: true,
						},
						{
							name: 'Neugeschäft im 5-Jahresverlauf',
							icon: '',
							path: 'agtneugesch5jahre',
							component: <AgtNeugeschaeft />,
							datenStand: <DatenStand dataType="aup_bestand" />,
							hideFilter: true,
						},
					],
				},
				{
					name: 'Agentur Cluster',
					icon: '',
					path: 'cluster',
					nodes: [],
				},
				{
					name: 'Werkzeugkoffer',
					icon: '',
					path: 'wkzgkoffer',
					nodes: [
						{
							name: '2026',
							icon: '',
							path: '2026',
							nodes: [
								{
									name: 'Übersicht',
									icon: '',
									path: 'overview',
									component: <WerkzeugkofferOverviewListe year={2026} />,
									datenStand: <DatenStand dataType="wkzgkoffer" />,
								},
								{
									name: 'Fahrzeugwechsel',
									icon: '',
									path: 'fzw',
									component: <WerkzeugkofferFzwListe year={2026} />,
									datenStand: <DatenStand dataType="wkzgkofferfzw" />,
								},
								{
									name: 'BAK',
									icon: '',
									path: 'bak',
									component: <WerkzeugkofferBakListe year={2026} />,
									datenStand: <DatenStand dataType="wkzgkofferbak26" />,
								},
							],
						},
						{
							name: '2025',
							icon: '',
							path: '2025',
							nodes: [
								{
									name: 'Übersicht',
									icon: '',
									path: 'overview',
									component: <WerkzeugkofferOverviewListe year={2025} />,
									datenStand: <DatenStand dataType="wkzgkoffer" />,
								},
								{
									name: 'Fahrzeugwechsel',
									icon: '',
									path: 'fzw',
									component: <WerkzeugkofferFzwListe year={2025} />,
									datenStand: <DatenStand dataType="wkzgkofferfzw" />,
								},
								{
									name: 'BAK',
									icon: '',
									path: 'bak',
									component: <WerkzeugkofferBakListe year={2025} />,
									datenStand: <DatenStand dataType="wkzgkofferbak" />,
								},
							],
						},
					],
				},
			],
		},
		{
			name: 'Kunde',
			icon: 'users',
			path: 'kunde',
			nodes: [
				{
					name: 'AKUMA',
					icon: '',
					path: 'akuma',
					visibileForRoles: AllSteartsExcept([Steart.DVSADMIN]),
				},

				{
					name: 'AMIS.NOW Aufgaben',
					icon: '',
					path: 'amisnow',
					visibileForRoles: [Steart.DVSADMIN],
					nodes: [
						{
							name: 'Aufgaben',
							icon: '',
							path: 'liste',
							component: <AmisNowListe />,
							datenStand: <DatenStand dataType="amisnow" />,
							lastPathIsParam: true,
						},
					],
				},

				{
					name: 'AMIS.NOW Leads',
					icon: '',
					path: 'leadnow',

					nodes: [
						{
							name: 'Ausgewählte ABV Abos',
							path: 'abv',
							icon: '',
							// visibileForRoles: AllSteartsExcept([Steart.DVSADMIN]),
							nodes: [
								{
									name: 'Brutto',
									icon: '',
									path: 'brutto',
									component: <LeadNowListe type={LeadNowType.brutto} />,
									datenStand: <DatenStand dataType="leadnow" />,
									downloadPdf: { supportSavedReports: true },
								},
								{
									name: 'Netto',
									icon: '',
									path: 'netto',
									component: <LeadNowListe type={LeadNowType.netto} />,
									datenStand: <DatenStand dataType="leadnow" />,
								},
								{
									name: 'Kunden werben Kunden',
									icon: '',
									path: 'kwk',
									component: <LeadNowKwkList />,
									datenStand: <DatenStand dataType="leadnowkwk" />,
									// visibileForRoles: Config.enableLeadNowKwk ? undefined : [Steart.DVSADMIN],
									// visibileForRoles: [Steart.DVSADMIN],
								},
								{
									name: 'Belieferung',
									icon: '',
									path: 'belieferung',
									component: <LeadNowVerteilungGoogleMap />,
									datenStand: <DatenStand dataType="leadnow" />,
								},
								{
									name: 'GeschaefstellenMap',
									icon: '',
									path: 'gsmaps',
									component: <GeschaefstellenMap />,
									datenStand: <DatenStand dataType="leadnow" />,
									visibileForRoles: [Steart.DVSADMIN],
								},
								{
									name: 'GP AMIS.Now Leads Nutzung',
									icon: '',
									path: 'consecutive',
									component: <LeadNowGpConsecutiveListe />,
									datenStand: <DatenStand dataType="leadnow" />,
									visibileForRoles: MultiSteartIds.concat([Steart.DVSADMIN]),
								},
							],
						},

						{
							name: 'Abschlußquote',
							path: 'conv',
							icon: '',
							nodes: [
								{
									name: 'Übersicht',
									icon: '',
									path: 'liste',
									component: <LeadNowConversionListe />,
									datenStand: <DatenStand dataType="leadnowconv" />,
								},
								{
									name: 'Historie',
									icon: '',
									path: 'history',
									component: <LeadNowConversionHistory />,
									datenStand: <DatenStand dataType="leadnowconv" />,
								},
							],
						},
					],
				},

				{
					name: 'KVM',
					icon: '',
					path: 'kvm',
					visibileForRoles: [Steart.DVSADMIN],
					nodes: [
						{
							name: 'Anrufe',
							icon: '',
							path: 'calls',
							component: <KvmListe />,
							datenStand: <DatenStand dataType="kvm" />,
						},
					],
				},
				{
					name: 'StS',
					icon: '',
					path: 'sts',
					visibileForRoles: [Steart.DVSADMIN],
					nodes: [
						{
							name: 'Sts',
							icon: '',
							path: 'sts',
							component: <StsListe />,
							datenStand: <DatenStand dataType="sts" />,
						},
					],
				},
				{
					name: 'Social-Media',
					icon: '',
					path: 'sm',
					nodes: [
						{
							name: 'Facebook',
							icon: '',
							path: 'facebook',
							component: <FacebookListe />,
							datenStand: <DatenStand dataType="facebook" />,
						},
						{
							name: 'Instagram',
							icon: '',
							path: 'instagram',
							component: <InstagramListe />,
							datenStand: <DatenStand dataType="instagram" />,
						},
						{
							name: 'TikTok',
							icon: '',
							path: 'tiktok',
							component: <TiktokListe />,
							datenStand: <DatenStand dataType="tiktok" />,
							visibileForRoles: [Steart.DVSADMIN],
						},
						{
							name: 'LinkedIn',
							icon: '',
							path: 'linkedin',
							component: <LinkedInListe />,
							datenStand: <DatenStand dataType="linkedin" />,
							visibileForRoles: [Steart.DVSADMIN],
						},
						{
							name: 'Sichtkontakte',
							icon: '',
							path: 'views',
							// visibileForRoles: MultiSteartIds.concat(Steart.DVSADMIN),
							visibileForRoles: [Steart.DVSADMIN],
							component: <SichtkontakteListe />,
							datenStand: <DatenStand dataType="facebook" />,
							downloadPdf: { supportSavedReports: true },
						},
						{
							name: 'Fans & Follower',
							icon: '',
							path: 'ff',
							visibileForRoles: MultiSteartIds.concat(Steart.DVSADMIN),
							component: <FansFollowerListe />,
							datenStand: <DatenStand dataType="facebook" />,
							downloadPdf: { supportSavedReports: true },
						},
						{
							name: 'GUP',
							icon: '',
							path: 'gup',
							component: <GoogleProfileListe />,
							datenStand: <DatenStand dataType="googleprofile" />,
							downloadPdf: { supportSavedReports: true },
						},
						{
							name: 'GP GUP 2026',
							icon: '',
							path: 'gupmultigp',
							component: <AgtGoogleProfileMultiGp26Liste />,
							datenStand: <DatenStand dataType="googleprofile" />,
							visibileForRoles: MultiSteartIds.concat(Steart.DVSADMIN),
						},
						{
							name: 'GP Sichtkontakte 2026',
							icon: '',
							path: 'viewsmultigp',
							visibileForRoles: MultiSteartIds.concat(Steart.DVSADMIN),
							component: <SichtkontakteListe gpMode={true} />,
							datenStand: <DatenStand dataType="facebook" />,
							downloadPdf: { supportSavedReports: true },
						},
					],
				},

				// {
				// 	name: 'Digitalisierungsfaktor',
				// 	icon: '',
				// 	path: 'digi',
				// 	nodes: [],
				// 	visibileForRoles: AllSteartsExcept([Steart.DVSADMIN]),
				// },
			],
		},
		{
			name: 'Personal',
			icon: 'address-card',
			path: 'personal',
			visibileForRoles: AllSteartsExcept([...MultiSteartIds]),

			nodes: [
				{ name: 'Geburtstagsliste', icon: '', path: 'geburtstag', component: <Geburstagsliste />, visibileForRoles: AllSteartsExcept([Steart.DVSADMIN, ...MultiSteartIds]) },
				{ name: 'Jubliäumsliste', icon: '', path: 'jubilaen', component: <Jubelliste />, visibileForRoles: AllSteartsExcept([Steart.DVSADMIN, ...MultiSteartIds]) },
				{ name: 'Agentur VBL Zuordnung', icon: '', path: 'agenturvbl', component: <AgenturVblListe />, visibileForRoles: [Steart.DVSADMIN] },
				//{ name: 'Pensionierung / Nachfolgeplanung', icon: '', path: 'pension', component: <Pensionsliste />, subTitle: 'Mitarbeiter die 55 Jahre oder älter sind' },
			],
		},
		{
			name: 'Errungenschaften',
			icon: 'trophy',
			path: 'errungenschaften',
			//visibileForRoles: AllSteartsExcept([Steart.DVSADMIN, ...MultiSteartIds]),
			hideFromAgt: true,

			nodes: [
				{ name: 'Übersicht', icon: '', path: 'overview', component: <AgtErrungenschaftenOverview /> },
				{ name: 'Agentur Errungenschaften', icon: '', path: 'agenturen', component: <AgtErrungenschaftenList /> },
			],
		},
		// {
		// 	name: 'Multi GP2025',
		// 	icon: 'sitemap',
		// 	path: 'multigp25',
		// 	visibileForRoles: [Steart.DVSADMIN],
		// 	nodes: [
		// 		{ name: 'Übersicht', icon: '', path: 'overview', component: <MultiGp2025 /> },
		// 		{ name: 'Gup Agt ', icon: '', path: 'gup', component: <FitnessTrackerGUP showMultiGPfields={true} /> },
		// 		{ name: 'SM Agt', icon: '', path: 'sm', component: <SociaMediaList /> },
		// 		{ name: 'AKUMA Agt', icon: '', path: 'akuma', component: <AkumaList /> },
		// 		{ name: 'AKUMA Agt by vd', icon: '', path: 'akumabyvd', component: <AkumaByVdList /> },
		// 		{ name: 'LeadNow Agt', icon: '', path: 'leadnow', component: <LeadNowGpConsecutiveListe /> },
		// 	],
		// },
		{
			name: 'DVS Nutzung',
			icon: 'sitemap',
			path: 'usage',
			visibileForRoles: [Steart.DVSADMIN],
			nodes: [
				{ name: 'Übersicht', icon: '', path: 'overview', component: <UsageOverview /> },
				{ name: 'Anmeldequote nach Funktionsgruppe', icon: '', path: 'anmeldequote', component: <UsageAnmeldequoteSteartYtd /> },
				{ name: 'Anmeldequote nach VD', icon: '', path: 'anmeldequotevd', component: <UsageAnmeldequoteVDYtd /> },
				{ name: 'Ø Anmeldungen nach VD', icon: '', path: 'loginavgvd', component: <UsageLoginAvgVdYtd /> },
				{ name: 'Ø Views nach VD', icon: '', path: 'viewsvd', component: <UsageViewVdYtd /> },
			]
		},

		{
			name: 'Multi GP2026',
			icon: 'sitemap',
			path: 'multigp',
			visibileForRoles: [Steart.DVSADMIN],
			nodes: [
				{ name: 'Übersicht', icon: '', path: 'overview', component: <MultiGp2026 /> },

				{
					name: 'GP Sichtkontakte 2026',
					icon: '',
					path: 'viewsmultigp',
					visibileForRoles: MultiSteartIds.concat(Steart.DVSADMIN),
					component: <SichtkontakteListe gpMode={true} />,
					datenStand: <DatenStand dataType="facebook" />,
					downloadPdf: { supportSavedReports: true },
				},
				{
					name: 'GP GUP 2026',
					icon: '',
					path: 'gupmultigp',
					component: <AgtGoogleProfileMultiGp26Liste />,
					datenStand: <DatenStand dataType="googleprofile" />,
					visibileForRoles: MultiSteartIds.concat(Steart.DVSADMIN),
				},
				{
					name: 'GP Akuma Nutzung',
					path: 'gp',
					component: <AkumaMultiGpList />,
					icon: '',
					visibileForRoles: MultiSteartIds.concat(Steart.DVSADMIN),
					datenStand: <DatenStandAkumaPrime />,
					downloadPdf: { supportSavedReports: true },
				},
				{
					name: 'GP AMIS.Now Leads Nutzung',
					icon: '',
					path: 'consecutive',
					component: <LeadNowGpConsecutiveListe />,
					datenStand: <DatenStand dataType="leadnow" />,
					visibileForRoles: [Steart.DVSADMIN],
				},
			],
		},
		{
			name: 'Orga',
			icon: 'sitemap',
			path: 'Orga',
			visibileForRoles: [Steart.GSL],
			nodes: [{ name: 'Betreuung', icon: '', path: 'unbetreut', component: <AgenturenBetreungList /> }],
		},
		{
			name: 'Dev',
			icon: 'code',
			path: 'dev',
			visibileForRoles: [Steart.DVSADMIN],
			nodes: [
				{
					name: 'Analytics Stores',
					icon: '',
					path: 'analytics-stores',
					component: <AnalyticsStoresList searchFilter="" />,
					hideFilter: true,
				},
				{
					name: 'Stores by Dimension',
					icon: '',
					path: 'stores-by-dimension',
					component: <AnalyticsStoresByDimensionList searchFilter="" />,
					hideFilter: true,
				},
			],
		},
	],
};
